<template>
    <b-modal 
        ref="baseDialog"
        :title="title"
        :no-close-on-backdrop="modal"
        hide-header-close
        @ok="handleConfirm"
    >
        <slot />

        <template v-slot:modal-footer="{ ok }">
            <b-button 
                @click="ok()"
                size="lg"
                variant="bq-red"
                pill
                v-if="!!cancelTitle"
            >
                {{ cancelTitle }}
            </b-button>
            <b-button 
                @click="ok()"
                size="lg"
                :variant="colorVariant"
                pill
            >
                {{ okTitle }}
            </b-button>
        </template>
  </b-modal>
</template>

<script>
  import colorVariantMixin from '@/components/mixins/colorVariantMixin';

  export default {
    name: 'baseDialog',
    mixins: [colorVariantMixin],
    props: {
        title: {
          type: String,
          default: 'Info'
        },
        modal: {
          type: Boolean,
          default: false,
        },
        okTitle: {
          type: String,
          default: 'Ok'
        },
        cancelTitle: {
          type: String
        },
    },
    methods: {
      show() {
        this.$refs.baseDialog.show();
      },
      handleConfirm() {
        this.$emit('confirm')
      }
    }
  }
</script>

<style scoped>

</style>
